module.exports = __webpack_public_path__ + "4902390a19757c8a9a051d762e13e75a.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2019-04-04/whats-new.html
// module id = 2247
// module chunks = 0